module.exports = __webpack_public_path__ + "img/report_2.1111fe17.png";